
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/humanize",
      function () {
        return require("private-next-pages/humanize.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/humanize"])
      });
    }
  